import './Footer.scss';

import React from 'react';
import { Link } from 'gatsby';

import logo from 'assets/images/harvard-easel-lab-logo.png';

const Footer: React.FC = () => {
  return (
    <div className="content-wrapper">
      <div className="Footer">
        <div className="Footer-links">
          <ul className="Footer-linkColumn-list">
            <li className="Footer-linkColumn-list-item">
              <Link className="Footer-linkColumn-link" to="/">
                Home
              </Link>
            </li>
            <li className="Footer-linkColumn-list-item">
              <Link className="Footer-linkColumn-link" to="/frameworks/">
                Frameworks
              </Link>
            </li>
            <li className="Footer-linkColumn-list-item">
              <Link className="Footer-linkColumn-link" to="/terms/">
                Terms
              </Link>
            </li>
          </ul>
        </div>
        <a href="https://easel.gse.harvard.edu/" className="Footer-logo">
          <img
            src={logo}
            alt="Easel Labs, Harvard Graduate School of Education"
          />
        </a>
      </div>
      <div className="Footer-credit">
        Design and Development by{' '}
        <a className="Footer-credit-link" href="https://friendsoftheweb.com/">
          Friends of The Web
        </a>
      </div>
    </div>
  );
};

export default Footer;
